/** A read deadline is a latency error; a write deadline cannot prove rollback. */
export function productionRequestOutcome(method: string, path: string, timedOut: boolean, code: string | null) {
  const write = !["GET", "HEAD"].includes(method.toUpperCase()) && path !== "/api/production/terminal/bootstrap";
  const uncertain = timedOut || (code !== null && ["NETWORK_ERROR", "INVALID_API_RESPONSE", "HTTP_500", "HTTP_502", "HTTP_503", "HTTP_504"].includes(code));
  if (write && uncertain) return "OPERATION_OUTCOME_UNKNOWN";
  return timedOut ? "CLIENT_REQUEST_TIMEOUT" : null;
}
